import { SvgIcon } from '@mui/material'

export function ArrowRightIcon(props) {
  return (
    <SvgIcon {...props} fill={'none'}>
      <path
        d="M5 12H19M19 12L12 5M19 12L12 19"
        fill={'none'}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
